import { useAuthLogout } from '../../../uc-api-sdk';

interface LogoutOptions {
  notifyServer?: boolean;
  redirectUrl?: string | null;
}

export const useLogout = () => {
  const logoutInfo = useAuthLogout({ options: { sendOnMount: false, retry: 0 } });

  const onLogout = async ({
    notifyServer,
    redirectUrl = '/',
  }: LogoutOptions = {}) => {
    try {
      if (notifyServer) {
        await logoutInfo.send({ params: {} });
      }
    } catch (error) {
      console.error(error);
    } finally {
      sessionStorage.clear();
      window.dispatchEvent(new Event('session-storage'));
      setTimeout(() => {
        if (redirectUrl) {
          window.location.href = redirectUrl;
        }
      }, 1000);
    }
  };

  return {
    onLogout,
    isLoggingOut: !!logoutInfo.isLoading,
  };
};
